import React from 'react';
export function HowItWorks() {
  return <>
      <section className="py-20 bg-brand-dark" data-id="element-113">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-114">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-115">
            Tu Rescate Capilar en 3 Fases Lógicas
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-116">
            {/* Connecting line (Desktop) */}
            <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-brand-gold/30 -z-10" data-id="element-117"></div>

            {/* Step 1 */}
            <div className="glass-card p-8 rounded-lg text-center relative z-10 group hover:-translate-y-2 transition duration-300" data-id="element-118">
              <div className="w-20 h-20 bg-brand-dark border-2 border-brand-gold rounded-full flex items-center justify-center mx-auto mb-6 text-2xl text-brand-gold font-heading font-bold shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-119">
                1
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-4" data-id="element-120">
                Extracción Pura
              </h3>
              <p className="text-gray-400 text-sm font-light" data-id="element-121">
                Aprenderás el método exacto en tu cocina para aislar el Gingerol
                sin destruir sus enzimas térmicas. Toma 3 minutos y cuesta
                centavos.
              </p>
            </div>

            {/* Step 2 */}
            <div className="glass-card p-8 rounded-lg text-center relative z-10 group hover:-translate-y-2 transition duration-300" data-id="element-122">
              <div className="w-20 h-20 bg-brand-dark border-2 border-brand-gold rounded-full flex items-center justify-center mx-auto mb-6 text-2xl text-brand-gold font-heading font-bold shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-123">
                2
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-4" data-id="element-124">
                Inyección Térmica
              </h3>
              <p className="text-gray-400 text-sm font-light" data-id="element-125">
                Aplicas el tónico usando el protocolo de masaje de 4 vectores.
                Sentirás un calor reconfortante: es la sangre reactivando
                folículos muertos.
              </p>
            </div>

            {/* Step 3 */}
            <div className="glass-card p-8 rounded-lg text-center relative z-10 group hover:-translate-y-2 transition duration-300" data-id="element-126">
              <div className="w-20 h-20 bg-brand-dark border-2 border-brand-gold rounded-full flex items-center justify-center mx-auto mb-6 text-2xl text-brand-gold font-heading font-bold shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-127">
                3
              </div>
              <h3 className="font-heading text-xl font-bold text-white mb-4" data-id="element-128">
                Ciclo de 14 Días
              </h3>
              <p className="text-gray-400 text-sm font-light" data-id="element-129">
                Repites el proceso según el calendario. La caída se frena en la
                primera semana. Para el día 14, comienzas a ver "baby hairs" en
                las zonas ralas.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="section-separator" data-id="element-130"></div>
    </>;
}